import { render, staticRenderFns } from "./DeleteTypeJobSearchAssistance.vue?vue&type=template&id=5fc0b3cd&"
import script from "./DeleteTypeJobSearchAssistance.vue?vue&type=script&lang=js&"
export * from "./DeleteTypeJobSearchAssistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports